import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromApp from '@store';
import { Site } from '@shared/models';
import { ReportResponse } from '@shared/models/report-response.model';

@Component({
    selector: 'fc-site-detail-reports',
    templateUrl: './site-detail-reports.component.html',
    styleUrls: ['./site-detail-reports.component.scss'],
    standalone: false
})
export class SiteDetailReportsComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  displayedColumns: string[] = ['created', 'type', 'view'];
  reports: ReportResponse[] = null;

  @Input() site: Site;
  @Input() isAdmin = false;

  constructor(readonly store: Store<fromApp.AppState>, readonly router: Router) {}

  ngOnInit() {
    this.reports = this.site?.reportResponses;
  }

  viewReport(element: any) {
    this.router.navigate([...this.router.url.split('?')[0].split('/').filter(Boolean), 'report-response', element.id]);
  }
}
